module.exports = __webpack_public_path__ + "img/plus-o.da9844a3.svg";